import type { QueryClient } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { ThemeProvider } from 'next-themes'
import { useEffect, useRef } from 'react'
import { toast } from 'sonner'

import { Toaster } from '@/components/ui/Toaster'
import { TanStackQueryDevtools } from '@/libs/tanstack-query/TanStackQueryDevtools'
import { TanStackRouterDevtools } from '@/libs/tanstack-router/TanStackRouterDevtools'
import { useInviteRedirectStore } from '@/stores/inviteRedirect.store'

interface MyRouterContext {
  queryClient: QueryClient
}

const RootComponent = () => {
  const shownMessageRef = useRef<string | null>(null)
  const errorMessage = useInviteRedirectStore((state) => state.errorMessage)
  const clearErrorMessage = useInviteRedirectStore(
    (state) => state.clearErrorMessage,
  )

  useEffect(() => {
    if (!errorMessage) {
      return
    }

    if (shownMessageRef.current === errorMessage) {
      return
    }

    shownMessageRef.current = errorMessage
    toast.error(errorMessage)

    clearErrorMessage()
  }, [errorMessage, clearErrorMessage])

  return (
    <ThemeProvider attribute="class" enableSystem>
      <Outlet />
      <Toaster richColors />
      <TanStackRouterDevtools />
      <TanStackQueryDevtools />
    </ThemeProvider>
  )
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
})
